<div id="syllabus" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Syllabus</h2>
    <p class="inner-lead mt-3">
      The syllabi for all undergraduate and postgraduate programmes are prescribed by <strong>Chaudhary Devi Lal
        University (CDLU), Sirsa</strong>. Students are advised to download and refer to the latest university syllabus
      for their respective programmes.
    </p>

    <hr class="divider">

    <div class="highlight-box mt-section">
      <div class="highlight-number">
        <i class="fa fa-book" style="font-size: 2rem;"></i>
      </div>
      <div class="highlight-label mt-2">
        Syllabus is available via the CDLU University Portal
      </div>
    </div>

    <div class="mt-section">
      <a href="https://www.cdlu.ac.in/index.php/examinations-details/111.html" target="_blank" class="pdf-download-btn">
        <i class="fa fa-external-link"></i> View Syllabus on Portal
      </a>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Programme-wise Syllabus</h4>
    <ul class="download-list mt-3">
      <li class="download-item">
        <span class="download-item-label">BA / B.Com / BBA / BAJMC Syllabus</span>
        <span class="download-item-meta">CDLU, Sirsa</span>
        <a href="https://share.google/U0oj4Lslh9lB9wqci" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> View
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">B.Sc / BCA Syllabus</span>
        <span class="download-item-meta">CDLU, Sirsa</span>
        <a href="https://share.google/U0oj4Lslh9lB9wqci" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> View
        </a>
      </li>
      <li class="download-item">
        <span class="download-item-label">MA / M.Com / M.Sc Syllabus</span>
        <span class="download-item-meta">CDLU, Sirsa</span>
        <a href="https://share.google/U0oj4Lslh9lB9wqci" target="_blank" class="download-btn">
          <i class="fa fa-external-link"></i> View
        </a>
      </li>
    </ul>

  </div>
</div>